var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticClass:"g-wrapper g-vertical-block"},[_c('Content',{staticClass:"g-main-wrapper g-vertical-block"},[_c('Tabs',{attrs:{"value":"toutiaov3project"}},[_c('TabPane',{attrs:{"name":"toutiaov3project","label":"项目"}})],1),_c('div',{staticClass:"c-content"},[_c('keep-alive',{attrs:{"max":10}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }